<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1000"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <div class="spec-info__container">
          <div class="spec-info__wrapper d-flex">
            <div class="spec-img__wrapper">
              <el-image
                :src="
                  formData.defaultImageUrl
                    ? $osscdn(formData.defaultImageUrl)
                    : '/image/static/img/nopic.jpg'
                "
                :preview-src-list="[
                  formData.defaultImageUrl || '/image/static/img/nopic.jpg',
                ]"
                class="spec-img"
              >
                <div slot="error" class="image-slot">
                  <img src="/image/static/img/nopic.jpg" class="spec-img" />
                </div>
              </el-image>
              <br />
              <el-button
                class="button_class"
                @click="openImgChoose"
                v-if="!disabled"
                >{{
                  $l('INDEX.evg_sku_label_edit_picture') || '编辑图片'
                }}</el-button
              >
            </div>

            <div class="spec-detail__wrapper">
              <el-form
                ref="form"
                :model="formData"
                :disabled="disabled"
                :rules="rules"
                size="small"
              >
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specNo') || '规格编号'"
                    >
                      <el-input
                        v-model="formData.specNo"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_no') ||
                            '请输入规格编号'
                        "
                        readonly
                        :disabled="disabled"
                        size="small"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="''">
                      <div style="margin-top: 35px;">
                        {{
                          $l('INDEX.evg_sku_label_auto') ||
                            '系统自动生成的编号，不需手工录入'
                        }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specName') || '规格名称'"
                      prop="specName"
                    >
                      <el-input
                        v-model="formData.specName"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_name') ||
                            '请输入规格名称'
                        "
                        :disabled="disabled"
                        maxlength="200"
                        clearable
                        size="small"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="
                        $l('INDEX.evg_sku_label_specNameEn') || '规格名称英文'
                      "
                      prop="specNameEn"
                    >
                      <el-input
                        v-model="formData.specNameEn"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_name_en') ||
                            '请输入规格名称英文'
                        "
                        :disabled="disabled"
                        maxlength="200"
                        clearable
                        size="small"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsLength') || '长'"
                      prop="goodsLength"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_goodsLength') ||
                            '请输入长'
                        "
                        v-model="formData.goodsLength"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsWidth') || '宽'"
                      prop="goodsWidth"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_width') ||
                            '请输入宽'
                        "
                        v-model="formData.goodsWidth"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_goodsHeight') || '高'"
                      prop="goodsHeight"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :disabled="disabled"
                        :min="0"
                        :step="0.01"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_height') ||
                            '请输入高'
                        "
                        v-model="formData.goodsHeight"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specUnit') || '规格单位'"
                      prop="specUnit"
                    >
                      <dict-select
                        size="small"
                        :disabled="disabled"
                        clearable
                        filterable
                        v-model="formData.specUnit"
                        url="/master/common/dict/biz"
                        :body="{ dictType: 'specUnit' }"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_unit') ||
                            '请选择规格单位'
                        "
                      ></dict-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$l('INDEX.evg_sku_label_specQty') || '规格数量'"
                      prop="specQty"
                    >
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :disabled="disabled"
                        :precision="0"
                        :min="0"
                        :step="1"
                        :placeholder="
                          $l('INDEX.evg_sku_placeholder_spec_qty') ||
                            '请输入规格数量'
                        "
                        v-model="formData.specQty"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <SpecImageChoose
            :evgSkuCode="evgSkuCode"
            :visible.sync="showImageChoose"
            :title="$l('INDEX.evg_sku_label_image_maintenance') || '图片维护'"
            @setImage="setImage"
          >
          </SpecImageChoose>
        </div>

        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            style="width:100px"
            @click="save()"
            v-if="!disabled"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import SpecImageChoose from '../spec-image-choose'

export default {
  components: { SpecImageChoose },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
    title: { type: String, default: '' },
    evgSkuSpecCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      formData: {},
      showImageChoose: false,
      rules: {
        specName: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_specName') || '请输入',
          },
        ],
        specNameEn: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_specNameEn') || '请输入',
          },
        ],
        goodsLength: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_goodsLength') || '请输入',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_goodsWidth') || '请输入',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_goodsHeight') || '请输入',
          },
        ],
        specUnit: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_specUnit') || '请选择...',
            trigger: 'blur',
          },
        ],
        specQty: [
          {
            required: true,
            message: this.$l('INDEX.rules_evg_sku_specQty') || '请输入',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.evgSkuSpecCode) return
      this.$api
        .ecomEvgSkuSpecDetailApi({
          evgSkuSpecCode: this.evgSkuSpecCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    openImgChoose() {
      this.showImageChoose = true
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
    },
    setImage({ displayImageCode, displayImageUrl }) {
      this.formData.defaultImageUrl = displayImageUrl
      this.formData.defaultImageCode = displayImageCode
      this.showImageChoose = false
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      const params = {
        ...this.formData,
        evgSkuCode: this.evgSkuCode,
      }
      const res = await this.$api
        .ecomEvgSkuSpecSaveApi({ ...params })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.close()
    },

    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}

.spec-info__container {
  margin-top: 10px;
  border-radius: 5px;
  color: #101010;
  padding: 15px 15px;
  .spec-img__wrapper {
    .spec-img {
      width: 120px;
      height: 120px;
      border: 1px dashed #cecece;
      border-radius: 5px;
      margin-bottom: 5px;
      padding: 6px;
      margin-top: 10px;
      > img {
        width: 108px;
        height: 108px;
        border-radius: 3px;
      }
    }
    > img {
      width: 96px;
      height: 96px;
      border-radius: 3px;
    }
  }

  .spec-detail__wrapper {
    flex: 1;
    margin-left: 15px;
    .modify-info {
      display: flex;
      align-items: flex-end;
      color: #8e8e8e;
      font-size: 14px;
    }
  }
}
.button_class {
  width: 120px;
  height: 30px;
  line-height: 2px;
  border-radius: 4px !important;
}
::v-deep {
  .spec-detail__wrapper {
    .el-form-item__label {
      line-height: 30px !important;
    }
    .el-form-item {
      margin-bottom: 8px !important;
    }
  }
  .el-form-item__content {
    line-height: 20px !important;
  }
}
</style>
